import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { colors } from '../../colors';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SchoolIcon from '@mui/icons-material/School';
import GroupsIcon from '@mui/icons-material/Groups';
import WorkIcon from '@mui/icons-material/Work';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PublicIcon from '@mui/icons-material/Public';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const staticSections = [
    { name: 'Demographics', icon: <AccountCircleIcon /> },
    { name: 'Perspective', icon: <PsychologyIcon /> },
    { name: 'Admissions', icon: <SchoolIcon /> },
    { name: 'Belonging', icon: <GroupsIcon /> },
    { name: 'Livelihood', icon: <WorkIcon /> },
    { name: 'Support', icon: <SupportAgentIcon /> },
    { name: 'Careers', icon: <TrendingUpIcon /> },
    { name: 'Experience', icon: <PublicIcon /> },
    { name: 'Submit', icon: <CheckCircleIcon /> },
];

const NavigationPane = ({ sectionNames = [], currentSectionIndex, onSectionClick }) => {
    console.log('sectionNames', sectionNames);
    return (
        <Box
            sx={{
                width: '22%', // Fixed width as 20% of the parent container
                flexShrink: 0, // Prevent it from shrinking
                color: colors.primaryApplicationText,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                padding: '20px',
                borderRadius: '8px',
            }}
        >
            {/* Survey Name */}
            <Box sx={{ mb: 2 }}>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: '1.2rem',
                        letterSpacing: '1px',
                        color: colors.racineRedDark,
                    }}
                >
                    Survey Name
                </Typography>
            </Box>
            {/* Separator */}
            <Box
                sx={{
                    height: '1px',
                    width: '100%',
                    backgroundColor: colors.racineRedDark,
                    mb: 1,
                }}
            />

            {/* Dynamic Sections List */}
            <List>
                {sectionNames.length > 0 ? (
                    sectionNames.map((section, index) => (
                        <ListItem
                            key={index}
                            button
                            disabled={!section.completed && index !== currentSectionIndex} // Allow clicking for completed sections or current section
                            onClick={() => {
                                if (section.completed || index === currentSectionIndex) {
                                    onSectionClick(index);
                                }
                            }}
                            sx={{
                                backgroundColor: index === currentSectionIndex ? 'white' : 'transparent',
                                color: section.completed
                                    ? colors.primaryApplicationText // Darker color for completed sections
                                    : index === currentSectionIndex
                                        ? colors.primaryApplicationText
                                        : '#ccc', // Lighter color for incomplete sections
                                '&:hover': {
                                    backgroundColor: section.completed || index === currentSectionIndex ? 'white' : 'transparent',
                                    color: section.completed || index === currentSectionIndex
                                        ? colors.primaryApplicationText
                                        : '#ccc',
                                    cursor: section.completed || index === currentSectionIndex ? 'pointer' : 'not-allowed', // Indicate clickable sections
                                },
                                cursor: section.completed || index === currentSectionIndex ? 'pointer' : 'not-allowed', // Default cursor for sections
                                borderRadius: '8px',
                                marginBottom: '10px',
                                padding: '10px 15px',
                                transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                            }}
                        >
                            {/* Icon and Text */}
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                {/* Static Icon */}
                                {staticSections[index]?.icon && (
                                    <Box sx={{ fontSize: '1.2rem', marginRight: '10px' }}>{staticSections[index].icon}</Box>
                                )}
                                <ListItemText
                                    primary={section.sectionTitle || `Section ${index + 1}`}
                                    primaryTypographyProps={{
                                        fontSize: '1rem',
                                        fontWeight: section.completed ? 'bold' : 'normal',
                                    }}
                                />
                                {/* Check Icon for Completed Sections */}
                                {section.completed && (
                                    <CheckCircleIcon
                                        sx={{
                                            color: colors.primaryBannerBlue,
                                            fontSize: '1.2rem', // Adjust size for better visibility
                                            marginLeft: 'auto', // Push to the right
                                        }}
                                    />
                                )}
                            </Box>
                        </ListItem>
                    ))
                ) : (
                    <Typography variant="body2" sx={{ color: '#aaa' }}>
                        No sections available
                    </Typography>
                )}
            </List>

        </Box>
    );
};

export default NavigationPane;
